import React, {useEffect, useState} from "react";
import axios from "axios";
import {httpStatus} from "../../../../lib/createRequestSaga";
import {errorHandle} from "../../../../lib/BuilderUtils";
import {DefaultCard, CardHeader, CardBody, CardFooter} from "../../../../pages/PageStyleBox";
import {useNavigate, useParams} from "react-router-dom";
import {Button, Form, message, Switch, Row, Col, Card, Tabs, Table} from "antd";
import {RightOutlined, ArrowRightOutlined} from "@ant-design/icons";
import {withTranslation} from "react-i18next";
import DefaultLoading from "../../DefaultLoading";
import ReportYearDef from "./page-setting/ReportYearDef";

const PageSetting = ({t}) => {
    const params = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const [studyPageList, setStudyPageList] = useState([]);
    const [reportYearList, setReportYearList] = useState([]);
    const [selectedColumnKey, setSelectedColumnKey] = useState(null);

    useEffect( () => {
        (async () => {
            try {
                const response = await axios.get(`/api/builder/studies/${params.sid}/page-setting`);
                if (response.status === httpStatus.ok) {
                    const studyPageList = response?.data?.studyPageList || [];
                    setStudyPageList(studyPageList);
                    form.setFieldsValue({studyPageList});

                    const reportYearList = response?.data?.reportYearList || [];
                    setReportYearList(reportYearList);
                    form.setFieldsValue({reportYearList });
                }
            } catch(e) {
                errorHandle(e, navigate);
            }
        })();
    }, []);

    const onFinish = async (values) => {

        // reportYear displayOrder 재정렬
        if (values?.reportYearList?.length > 0) {
            values.reportYearList = values.reportYearList.map((item, index) => ({
                ...item,
                orderNum: index + 1, // 1부터 시작
            }));
        }
        //console.log("Values:", JSON.stringify(values, null, 2));

        try {
            const response = await axios.post(`/api/builder/studies/${params.sid}/page-setting`, values);

            if(response.status === httpStatus.ok) {
                const {data} = response;
                message.success(data.message);
            }

        } catch (e) {
            errorHandle(e);
        }
    };

    const clickColumnInfo = (columnKey) => {

        console.log(columnKey);
        switch (columnKey) {
            case 'SUBJECT_LIST_REPORT_YEAR':
                setSelectedColumnKey('SUBJECT_LIST_REPORT_YEAR');
                break;
            default:
                setSelectedColumnKey(null);
        }
    };

    const clearColumnInfo = () => {
      
        setSelectedColumnKey(null);
    };

    const getColumnInfoTitle = (type) => {

        let defaultTitle = "Column Info";
        switch (type) {
            case 'SUBJECT_LIST_REPORT_YEAR':
                return defaultTitle + ' > Report Year Settings';
            default:
                return defaultTitle;
        }
    };

    return (
        <>
            {
                (studyPageList === null) &&
                 <DefaultLoading />
            }
            {
                 (studyPageList !== null) &&
                <DefaultCard>
                    <Form layout="vertical" form={form} onFinish={onFinish}>
                        <CardHeader>
                            <h3><RightOutlined className={'mr-2'} />Page Setting</h3>
                        </CardHeader>
                        <CardBody>
                            <Row style={{margin:'1rem'}}>
                                <Col span={12}>
                                    <Card title={<h5>Page Setting</h5>} style={{minHeight: "750px"}}>
                                        <Form.List name="studyPageList">
                                            {(fields) => (
                                                <Tabs tabPosition="left" type="line" onTabClick={() => clearColumnInfo()}>
                                                    {fields.map((field, idx) => {
                                                        return (
                                                            <Tabs.TabPane
                                                                tab={form.getFieldValue(['studyPageList', field.name, 'pageName'])}
                                                                key={form.getFieldValue(['studyPageList', field.name, 'pageKey'])}
                                                            >
                                                                <Form.List name={[field.name, 'studyPageColumnVOList']}>
                                                                    {(colFields) => (
                                                                        <Table
                                                                            bordered
                                                                            pagination={false}
                                                                            rowKey={(record, index) => index}
                                                                            dataSource={
                                                                                form.getFieldValue(['studyPageList', field.name, 'studyPageColumnVOList']) || []
                                                                            }
                                                                            columns={[
                                                                                {
                                                                                    title: 'Column Name',
                                                                                    dataIndex: 'columnName',
                                                                                    key: 'columnName',
                                                                                    align: 'center',
                                                                                    width: '40%',
                                                                                },
                                                                                {
                                                                                    title: 'Visible',
                                                                                    dataIndex: 'visible',
                                                                                    key: 'visible',
                                                                                    align: 'center',
                                                                                    width: '30%',
                                                                                    render: (_, __, colIndex) => (
                                                                                        <Form.Item name={[colIndex, 'visible']} valuePropName="checked" noStyle>
                                                                                            <Switch />
                                                                                        </Form.Item>
                                                                                    )
                                                                                },
                                                                                {
                                                                                    title: 'Column Info',
                                                                                    dataIndex: 'columnInfo',
                                                                                    key: 'columnInfo',
                                                                                    align: 'center',
                                                                                    width: '30%',
                                                                                    render: (val, record) =>
                                                                                        val ? (
                                                                                            <Button type="primary" shape="circle" icon={<ArrowRightOutlined /> }
                                                                                                    onClick={() => clickColumnInfo(record.columnKey)}/>
                                                                                        ) : null,
                                                                                }
                                                                            ]}
                                                                        />
                                                                    )}
                                                                </Form.List>
                                                            </Tabs.TabPane>
                                                        );
                                                    })}
                                                </Tabs>
                                            )}
                                        </Form.List>
                                    </Card>
                                </Col>
                                <Col span={11} offset={1}>
                                    <Card title={<h5>{getColumnInfoTitle(selectedColumnKey)}</h5>} style={{minHeight: "100%"}}>
                                            {/*Report Year*/}
                                            <div style={{display: selectedColumnKey === 'SUBJECT_LIST_REPORT_YEAR' ? "block" : "none"}}>
                                                <ReportYearDef />
                                            </div>
                                    </Card>
                                </Col>
                            </Row>
                        </CardBody>
                        <CardFooter>
                            <Form.Item className={'text-right'}>
                                <Button type="primary" htmlType="submit">Save</Button>
                            </Form.Item>
                        </CardFooter>
                    </Form>
                </DefaultCard>
            }
        </>
    )
}

export default withTranslation()(PageSetting);
